import cx from "classnames";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withToast } from "../contexts/toastr.context";
import useLang from "../hooks/use-lang.hook";
import questionIcon from "../_assets/vectors/question-icon.svg";
import I18 from "../_components/atoms/i18";
import { Loader } from "../_components/loader.component";
// import { TagCardList} from '../_components/tag-card-list.component';
import { PostCardList } from "../_components/post/post-card-list.component";
import { PostService } from "../_service/post.service";
// import { TagCardList } from '../_components';

export const TAG_PAGE_ROUTE = "/tagged";
export const showTagPageRoute = (tagName) => "/tagged?tag=" + tagName;

function TagPageDetailsComponent({ user, community, groups, updateGroups }) {
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [isGroupDropdownVisible, setIsGroupDropdownVisible] = useState(false);
  const [isSectionDropdownVisible, setIsSectionDropdownVisible] =
    useState(false);
  const [isGroupSelected, setIsGroupSelected] = useState("All Groups");
  const [isSectionSelected, setIsSectionSelected] = useState("All Channels");
  const [isActiveSectionId, setIsActiveSectionId] = useState("");
  const [activeGroupId, setActiveGroupId] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const lang = useLang();

  //
  const [isLoadingMorePosts, setIsLoadingMorePosts] = useState(false);
  const [noMorePosts, setNoMorePosts] = useState(false);

  // Searched Tag
  const [posts, setPosts] = useState([]);

  const inputRef = useRef();

  const location = useLocation();

  // hide on clicking outside this
  useEffect(() => {
    const closeMenuListener = (e) => {
      if (isGroupDropdownVisible) {
        setIsGroupDropdownVisible(false);
      } else if (isSectionDropdownVisible) {
        setIsSectionDropdownVisible(false);
      }
    };
    window.document.body.addEventListener("click", closeMenuListener);
    return () => {
      window.document.body.removeEventListener("click", closeMenuListener);
    };
  }, [isGroupDropdownVisible, isSectionDropdownVisible]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tag = urlParams.get("tag");
    if (tag !== undefined && tag !== "") {
      setQuery(`#${tag}`);
      getPosts(user, community.id, 1, tag, "", "");
    } else if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [user, community, location]);

  const getPosts = async (user, communityId, page, tags, tabId, groupId) => {
    setIsLoadingMorePosts(true);
    let searchTagResponse = await PostService.getPostByTagSearch(
      user,
      communityId,
      page,
      tags,
      tabId,
      groupId
    );
    await setPosts(searchTagResponse.posts);
    setIsLoadingMorePosts(false);
  };

  const selectGroup = async (name, id) => {
    let sectionListArr = [];
    setIsGroupSelected(name);
    setCurrentPage(1);
    sectionListArr = groups.filter((item) => item.name === name);
    sectionListArr.length > 0
      ? setSectionList(sectionListArr[0].tabs)
      : setSectionList([]);
    setIsSectionSelected("All Channel");
    getPosts(user, community.id, 1, query.slice(1), "", id);
    setActiveGroupId(id);
    setNoMorePosts(false);
  };

  const selectSection = async (name, id) => {
    await setIsSectionSelected(name);
    setCurrentPage(1);
    await getPosts(user, community.id, 1, query.slice(1), id, activeGroupId);
    await setIsActiveSectionId(id);
    setNoMorePosts(false);
  };
  // post lazy loading
  useEffect(() => {
    // create callback
    const callBack = () => {
      if (
        window.innerHeight + window.scrollY + 100 >=
        document.body.offsetHeight
      ) {
        if (!isLoadingMorePosts && !noMorePosts) {
          // if we are not already loading more posts, load more posts
          setIsLoadingMorePosts(true);
          PostService.getPostByTagSearch(
            user,
            community.id,
            currentPage + 1,
            query.slice(1),
            isActiveSectionId,
            activeGroupId
          ).then((response) => {
            // if there are no more posts, set so
            if (response.posts.length === 0) {
              setNoMorePosts(true);
            } else {
              setPosts([...posts, ...response.posts]);
              setCurrentPage(response.page);
            }
            setIsLoadingMorePosts(false);
          });
        }
      }
    };

    window.addEventListener("scroll", callBack);

    return () => {
      window.removeEventListener("scroll", callBack);
    };
  }, [isLoadingMorePosts, user, currentPage, posts, noMorePosts, community.id]);

  return (
    <>
      <div className="TagPage">
        {/* Header of tag search page */}
        <div className="GroupInfo mb-4 rounded bg-card px-3 py-2">
          <div className="flex items-center justify-between">
            <div
              className={cx(
                "w-full overflow-ellipsis p-4 pb-3 font-bold text-secondary-foreground/85"
              )}>
              <div className="mb-4 flex items-center rounded border border-border bg-background px-4 py-1">
                <input
                  type="text"
                  ref={inputRef}
                  placeholder={lang.trans("Search for tags")}
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value);
                  }}
                  className="flex-grow bg-transparent px-4 py-1 font-bold text-secondary-foreground/80 focus:outline-none"
                />
                <img
                  onClick={() =>
                    getPosts(
                      user,
                      community.id,
                      currentPage,
                      query.slice(1),
                      ""
                    )
                  }
                  src={questionIcon}
                  alt=""
                  className="search-tag-icon cursor-pointer"
                  style={{ filter: "opacity(0.5)", width: "18px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="pl-4">
              <div className="dropdown relative inline-block">
                <button
                  onClick={(e) =>
                    setIsGroupDropdownVisible(!isGroupDropdownVisible)
                  }
                  className="inline-flex items-center rounded bg-primary px-4 py-2 font-semibold text-primary-foreground">
                  <span className="mr-1">{isGroupSelected}</span>
                  <svg
                    className="h-4 w-4 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                  </svg>
                </button>
                {isGroupDropdownVisible ? (
                  <ul className="absolute z-10 block p-0 pt-1 text-secondary-foreground/85">
                    <li
                      onClick={() => selectGroup("All Groups", "")}
                      className="cursor-pointer list-none">
                      <span className="theme-bg-disable whitespace-no-wrap block rounded-t px-4 py-2 hover:bg-background">
                        <I18>All Groups</I18>
                      </span>
                    </li>
                    {groups
                      ? groups.map((item, index) => {
                          return (
                            <li
                              key={index}
                              onClick={() => selectGroup(item.name, item.id)}
                              className="cursor-pointer list-none">
                              <span className="theme-bg-disable whitespace-no-wrap block rounded-t px-4 py-2 hover:bg-background">
                                {item.name}
                              </span>
                            </li>
                          );
                        })
                      : null}
                  </ul>
                ) : null}
              </div>
            </div>
            <div className="pl-4">
              {isGroupSelected !== "All Groups" ? (
                <div className="dropdown relative inline-block">
                  <button
                    onClick={(e) =>
                      setIsSectionDropdownVisible(!isSectionDropdownVisible)
                    }
                    className="inline-flex items-center rounded bg-primary px-4 py-2 font-semibold text-primary-foreground">
                    <span className="mr-1">{isSectionSelected}</span>
                    <svg
                      className="h-4 w-4 fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                    </svg>
                  </button>
                  {isSectionDropdownVisible ? (
                    <ul className="absolute z-10 block p-0 pt-1 text-secondary-foreground/85">
                      <li
                        onClick={() => selectSection("All Channel", "")}
                        className="cursor-pointer list-none">
                        <span className="theme-bg-disable whitespace-no-wrap block rounded-t px-4 py-2 hover:bg-background">
                          <I18>All Channel</I18>
                        </span>
                      </li>
                      {sectionList
                        ? sectionList.map((item, index) => {
                            return (
                              <li
                                key={index}
                                onClick={() =>
                                  selectSection(item.name, item.id)
                                }
                                className="cursor-pointer list-none">
                                <span className="theme-bg-disable whitespace-no-wrap block rounded-t px-4 py-2 hover:bg-background">
                                  {item.name}
                                </span>
                              </li>
                            );
                          })
                        : null}
                    </ul>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {/* Tag card */}
        <div>
          <div className="pl-2">
            <span className="font-bold text-secondary-foreground/70">
              <I18>SEARCH RESULT</I18>
            </span>
          </div>
          {!isLoadingMorePosts && posts.length > 0 ? (
            <PostCardList posts={posts} allPosts={posts} setPosts={setPosts} />
          ) : (
            <></>
          )}
          {isLoadingMorePosts ? (
            <div className="align-center flex justify-center py-5">
              <Loader />
            </div>
          ) : posts.length === 0 ? (
            <div className="text-center font-semibold text-secondary-foreground/70">
              <I18>No posts found for selected hashtag</I18>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="secondary-sidebar pr-5"></div>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  community: state.community,
  groups: state.groups,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const TagPageDetails = withToast(
  connect(mapStateToProps, mapDispatchToProps)(TagPageDetailsComponent)
);

export default TagPageDetails;
